import React from 'react';
import CardList from '../Components/CardList';
import SearchBox from '../Components/SearchBox';
import Scroll from '../Components/Scroll';
import ErrorBoundary from '../Components/ErrorBoundary';
import './app.css';

class App extends React.Component {
    constructor() {
        super();
        this.state = {
            Heroes: [],
            searchfield: ''
        };

    }
    componentDidMount() {
        fetch('https://jsonplaceholder.typicode.com/users')
            .then(response => response.json())
            .then(users => this.setState({ Heroes: users }));
    }

    onSearchChange = (event) => {
        this.setState({ searchfield: event.target.value })
    }

    render() {
        const {Heroes,searchfield}=this.state;
        const filteredHeroes = Heroes.filter(heroes => {
            return heroes.name.toLowerCase().includes(searchfield.toLowerCase())
        });
        if (!Heroes.length) {
            return <h1>Loading...</h1>
        }
        else {
            return (
                <div className='tc'>
                    <h1 className='f2'>RoboFriends</h1>
                    <SearchBox searchChange={this.onSearchChange} />
                    <Scroll>
                        <ErrorBoundary>
                        <CardList Heroes={filteredHeroes} />
                        </ErrorBoundary>
                    </Scroll>
                </div>

            );
        }

    }

}

export default App;